import { Box, Typography } from "@mui/material"
import { ReactNode } from "react"

const HistoryParagraph = ({ children }: { children: ReactNode }) => {
    return (
        <Typography
            variant='body1'
            sx={{
                mt: 3,
                textAlign: 'center',
                fontSize: {
                    xs: '1rem',
                },
            }}
        >
            {children}
        </Typography>
    )
}

export const History = () => {
    return (
        <Box>
            <Typography
                variant="h3"
                align="center"
                sx={{
                    mt: 3,
                    fontWeight: 200,
                    fontSize: {
                        xs: '2rem',
                        sm: '3rem',
                    }
                }}>
                Our History
            </Typography>
            <HistoryParagraph>
                The first 40 acres were deeded on March 4, 1842 to Mathew Parke.
            </HistoryParagraph>
            <HistoryParagraph>
                The second 40 acres were deeded to Isabela Perry on February 7, 1891.
            </HistoryParagraph>
            <HistoryParagraph>
                After 8 transfers of ownership, the entire 80 acres were deeded to John
                McCutchen on September 22, 1899.
            </HistoryParagraph>
            <HistoryParagraph>
                The property was sold several times over the ensuing years, with it
                ultimately going into default over unpaid taxes and the mortgage (The
                mortgage being held by the Bank of Newburgh).
            </HistoryParagraph>
            <HistoryParagraph>
                In 1940; 5 employees of Indiana Bell Telephone Company formed The Bell
                Conservation Club, with one of their intentions to purchase the 80 acres.
            </HistoryParagraph>
            <HistoryParagraph>
                On July 26, 1940 the Bank of Newburgh sold the 80 acres to the Bell Conservation
                Club for the sum of $ 1.00 and consideration ($ 500.00).
            </HistoryParagraph>
            <HistoryParagraph>
                On August 7, 1940 the Club purchased a 10 foot strip of property from Seven
                Hills Road to the Southwest corner of the property. This was to serve as the
                entrance to the Club. The ground was bought from Albert Horn for the sum of $ 1.00.
            </HistoryParagraph>
            <HistoryParagraph>
                In 1940, prior to WWII, the economy was not doing well and the phone company's
                Linemen and other Plant Department workers normal workload was lite. The Company
                allowed volunteers to use it's bulldozers and heavy equipment to build the dam
                and form the lake; all while receiving their normal pay. The lake is 14+ acres
                and approximately 30' at it's deepest depth.
            </HistoryParagraph>
            <HistoryParagraph>
                When the ground was purchased the only building was a 18x12 concrete block room
                (the current kitchen), with a wood stove in the center of it. As Old Timers have
                relayed, “there was a heated argument” over the removal of the stove when the
                restrooms were added. Some time in the 50's the meeting room was added as a shelter
                with open walls.
            </HistoryParagraph>
            <HistoryParagraph>
                In 1962 the shelter house walls were enclosed and a tile floor and ceiling were installed,
                creating the present club house and screened porch. Over the years a sand beach was built,
                as well as the swimming pier and fishing dock.
            </HistoryParagraph>
            <HistoryParagraph>
                The club has grown from five members in 1940, to over 100 members in 2011.
            </HistoryParagraph>
            <HistoryParagraph>
                The Club is only able to be successful in providing a clean and safe environment
                for your family to picnic, camp and swim if all members respect each other,
                follow the rules, help during our very few work parties and attend the two Membership
                Meetings a year. We feel that there is no better place to enjoy the outdoors then
                at “The 80”!
            </HistoryParagraph>
            <Box sx={{
                textAlign: 'center',
                mt: 3,
                maxWidth: '100%',
            }}>
                <Box component='img' sx={{ maxWidth: '100%', }} src='./images/dnr.webp' />
            </Box>
        </Box>
    )
}